import { Check } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { TYPE_BADGE_CLASSES } from './constants';

// Re-export shared filter components from the alerts tab
export {
  FilePathFilterOption,
  UserFilterOption,
} from '@/pages/organization/tabs/DataTableAlertsTab/FilterComponents';

// ────────────────────────────────────────────────────────────
// TypeFilterOption
// ────────────────────────────────────────────────────────────

interface TypeFilterOptionProps {
  value: string;
  isSelected: boolean;
}

export function TypeFilterOption({ value, isSelected }: TypeFilterOptionProps) {
  const badgeClass =
    TYPE_BADGE_CLASSES[value] ?? 'bg-muted text-muted-foreground';
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <Badge variant="outline" className={badgeClass}>
        {value.charAt(0).toUpperCase() + value.slice(1)}
      </Badge>
    </div>
  );
}

// ────────────────────────────────────────────────────────────
// ProjectFilterOption
// ────────────────────────────────────────────────────────────

interface ProjectFilterOptionProps {
  /** Project display name (the option label). */
  label: string;
  isSelected: boolean;
}

export function ProjectFilterOption({
  label,
  isSelected,
}: ProjectFilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <span className="text-sm truncate" title={label}>
        {label}
      </span>
    </div>
  );
}
